import {
  GROUPING_DAMAGE_FAILED,
  GROUPING_DAMAGE_REQUEST,
  GROUPING_DAMAGE_SUCCESS,
} from "app/redux/actions/Factory/Grouping/groupingDamage/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const groupingDamageReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case GROUPING_DAMAGE_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case GROUPING_DAMAGE_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case GROUPING_DAMAGE_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
